import * as React from 'react';
import moment from 'moment';
import { transform } from 'inflection';

import styles from './styles.scss';

import CollapsiblePanel from './CollapsiblePanel';
import Link from 'buyside/components/presentation/Link/link';

import { getExtensionIcon } from 'buyside/util/fileHelper';
import { whitePaperAttachmentUrl } from 'buyside/util/urlHelper';

const CollapsibleAttachments: React.FC<{
  dataTag?: string;
  files: {
    id: string;
    filename: string;
    createdAt: string;
    attachmentType: string;
    fileType: string;
  }[];
  Icon: React.SVGFactory;
  researchType: string;
}> = ({ dataTag, files, Icon, researchType }): React.ReactElement => {
  const attachmentTypes = [...new Set(files.map((file): string => file.attachmentType))].sort();

  const researchTypeHeader = (
    <div>
      <Icon className={styles.titleIcon} />
      {researchType} ({files.length})
    </div>
  );

  return (
    <CollapsiblePanel dataTag={dataTag} title={researchTypeHeader}>
      <div className={styles.contentContainer}>
        {attachmentTypes.map(
          (type): React.ReactElement => (
            <CollapsiblePanel
              title={transform(type.replace('_', ' '), ['humanize', 'titleize'])}
              key={type}
            >
              {files
                .filter((file): boolean => file.attachmentType === type)
                .map(
                  ({ id, createdAt, filename, fileType }): React.ReactElement => {
                    const Icon = getExtensionIcon(fileType);

                    return (
                      <div className={styles.fileInfo} key={id}>
                        <div>
                          {' '}
                          <Link to={whitePaperAttachmentUrl(id)} target="_blank">
                            <span className={styles.fileName}>
                              <Icon className={styles.attachmentIcon} />
                              {filename}
                            </span>
                          </Link>
                        </div>
                        <div>{moment(new Date(createdAt || '')).format('M/D/YY')}</div>
                      </div>
                    );
                  }
                )}
            </CollapsiblePanel>
          )
        )}
      </div>
    </CollapsiblePanel>
  );
};

export default CollapsibleAttachments;
